export class StorageKeyConstants {
  static apiTokenName = 'cc-token';
  static apiLoginTokenName = 'cc-login-token';
  // Meeting Hub JWT obtained via POST {meetingHubApiUrl}/auth exchange (bearer cc-token).
  // Written by the dashboard meeting-hub widget and the meeting-hub MFE; must be
  // cleared on logout so a stale (still-non-expired) JWT minted under old DB
  // state doesn't leak into the next session and trigger 403s post-fix.
  static meetingHubTokenName = 'mh-token';
  static userInfo = 'rp-user-info'; //display user info
  static loggedInUserInfo = 'rp-logged-in-user-info';
  static selectedPropertyKey = 'rp-selected-property';
  static impersonateHistory = 'impersonate-history';

  static userThemeKey = 'cc-devex-theme-color';
  static userTimeZoneKey = 'cc-time-zone-name';
  static userPrecisionKey = 'cc-precision';

  static chartPaletteKey = 'cc-chart-palette-name';
  static chartPaletteExtentionKey = 'cc-chart-palette-extention-mode-name';

  static onetimePaymentLeftPanelWidthInPercent =
    'cc-onetime-payment-left-panel-width';
  static onetimePaymentRightPanelWidthInPercent =
    'cc-onetime-payment-right-panel-width';

  static onetimePaymentResultLogKey = 'one-time-payment-result-log-key';
  static rememberedLoginKey = 'cc-remembered-login-info';

  static ciraHelpSidebarSizes = 'cc_cirahelp_sidebar_sizes';

  static realAssistSessionId = 'chatbot-session-id';

  // Session storage keys
  static inactivityLogoutKey = 'inactivity-logout';
  static chunkLoadReloadAttempts = 'chunk-load-reload-attempts';

  static surveyDismissedPrefix = 'cira_survey_dismissed_';
  static surveySessionCount = 'cira_survey_session_count';
}
